var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex items-center rounded-full font-medium gap-2",class:_vm.style,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }